<nf-grid-wrapper [hideSearch]="true" [hideClearAll]="true">
  <nf-grid-wrapper-header-left>
    <div class="wb-left">
      <span class="wb-role">{{ roleLabel }}</span>
      <div ngbDropdown class="wb-source-picker">
        <button
          type="button"
          ngbDropdownToggle
          class="wb-source-toggle"
          [attr.aria-label]="roleLabel + ' source'"
        >
          <span class="wb-source">
            <span class="wb-source-name">{{ source?.label }}</span>
            <span class="wb-source-tag" [style.color]="source?.tagColor">{{
              source?.tag
            }}</span>
          </span>
          <i class="mdi mdi-chevron-down wb-source-caret"></i>
        </button>
        <div ngbDropdownMenu class="wb-source-menu">
          <h6 class="dropdown-header">{{ roleLabel }} Source</h6>
          <!-- A source held back for now stays listed but disabled, so the pairing the workbench
               is built for is still discoverable. -->
          <button
            *ngFor="let option of sourceOptions"
            type="button"
            ngbDropdownItem
            class="wb-source-option"
            [class.wb-source-current]="option.key === sourceKey"
            [disabled]="option.disabled"
            (click)="onSourcePicked(option.key)"
          >
            <span class="wb-source">
              <span class="wb-source-name">{{ option.label }}</span>
              <span
                class="wb-source-tag wb-source-tag-sm"
                [style.color]="option.tagColor"
                >{{ option.tag }}</span
              >
            </span>
            <i
              class="mdi mdi-check wb-source-check"
              *ngIf="option.key === sourceKey"
            ></i>
          </button>
        </div>
      </div>
    </div>
  </nf-grid-wrapper-header-left>

  <ng-grid-wrapper-header-right class="d-flex" *ngIf="source?.hasStatusFilter">
    <div id="status-quickfilter" class="d-flex mr-2">
      <nf-checkbox
        class="small"
        label="Unmatched"
        [formControl]="includeUnmatchedFormControl"
      ></nf-checkbox>
      <nf-checkbox
        class="small"
        label="Ignored"
        [formControl]="includeIgnoredFormControl"
      ></nf-checkbox>
      <nf-checkbox
        class="small"
        label="Matched"
        [formControl]="includeMatchedFormControl"
      ></nf-checkbox>
    </div>
  </ng-grid-wrapper-header-right>

  <ng-grid-wrapper-header-right class="d-flex" *ngIf="isClearwater">
    <div id="quickfilter-container" class="d-flex mr-2">
      <nf-checkbox
        class="small"
        label="Hide Future Post Dates"
        [formControl]="hideFuturePostDatesToggle"
      ></nf-checkbox>
      <nf-checkbox
        class="small"
        label="Post Date Today"
        [formControl]="filterPostDateTodayToggle"
      ></nf-checkbox>
      <nf-checkbox
        class="small"
        label="Cleared"
        [formControl]="filterClearedToggle"
      ></nf-checkbox>
      <nf-checkbox
        class="small"
        label="Uncleared"
        [formControl]="filterUnclearedToggle"
      ></nf-checkbox>
    </div>
  </ng-grid-wrapper-header-right>

  <ng-grid-wrapper-header-right class="d-flex" *ngIf="isClearwater">
    <nf-form-control class="d-flex mr-2" style="max-width: 8rem" compact>
      <ng-select
        placeholder="FX Currency"
        [formControl]="fxCurrencyFilter"
        [items]="fxCurrencyFilterItems"
        [multiple]="true"
        class="multi-select"
        [closeOnSelect]="false"
        clearAllText="Clear"
        [clearable]="true"
        [clearOnBackspace]="true"
      >
        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
          <div
            *ngIf="items.length > 1; else singleItem"
            class="ng-value nf-custom-badge"
          >
            <span class="ng-value-label"> {{ items.length }} selected </span>
          </div>
          <ng-template #singleItem>
            <div class="ng-value nf-custom-badge">
              <span
                class="ng-value-label"
                *ngFor="let item of items; index as i"
                >{{ item }}</span
              >
            </div>
          </ng-template>
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <div container="body" class="ellipsis">
            {{ item }}
          </div>
        </ng-template>
      </ng-select>
    </nf-form-control>
  </ng-grid-wrapper-header-right>

  <ng-grid-wrapper-header-right>
    <nf-form-control class="d-flex mr-2" compact for="quickSearch">
      <!-- Per the 2.0 design this filters ONE identifier column per source, server-side — see
           grid/filters/search-filter.ts. Disabled when this account's catalog lacks that column. -->
      <input
        type="text"
        class="form-control"
        data-cy="grid-search"
        [formControl]="quickSearch"
        [placeholder]="searchPlaceholder"
        [attr.title]="
          quickSearch.disabled
            ? 'This column is not available for this account'
            : null
        "
      />
    </nf-form-control>
  </ng-grid-wrapper-header-right>

  <ng-grid-wrapper-header-right *ngIf="source?.hasCreate">
    <!-- Create asks what KIND of document you are making first: Clearwater lists its posting types,
         Enfusion a "Trade" submenu of all fourteen trade types plus GL Entry — the prototype's full
         Create menu, every item opening its own metadata-built dialog. `autoClose="outside"` is what
         keeps hovering "Trade" from closing the whole menu, since ngbDropdown would otherwise treat
         any inside click the same way; selection closes it explicitly instead. A source added before
         its create flow has been designed carries no `hasCreateMenu` and gets a plain button; no
         source is in that state today. -->
    <div
      *ngIf="source?.hasCreateMenu; else createAction"
      ngbDropdown
      #createDropdown="ngbDropdown"
      autoClose="outside"
      placement="bottom-right"
      (openChange)="onCreateMenuOpenChange()"
    >
      <button
        nf-button="create"
        id="create-transaction-dropdown"
        ngbDropdownToggle
        ngbTooltip="Create Transaction"
        placement="bottom-right"
      ></button>
      <div
        ngbDropdownMenu
        aria-labelledby="create-transaction-dropdown"
        class="dropdown-menu dropdown-menu-right"
      >
        <ng-container *ngFor="let item of createMenuItems">
          <!-- A leaf item: the Clearwater posting types, and Enfusion's GL Entry. Entering one also
               closes the Trade flyout, as it does in the prototype. -->
          <button
            *ngIf="!item.children"
            type="button"
            ngbDropdownItem
            (mouseenter)="setCreateTradeSubmenu(false)"
            (click)="onCreate(item.tranCategory); createDropdown.close()"
          >
            {{ item.label }}
          </button>
          <!-- "Trade": hovering opens a flyout of the fourteen trade types beside the menu. It opens
               to the left because the Create menu is right-aligned against the toolbar edge, which is
               the side the prototype flips to in the same position. -->
          <div
            *ngIf="item.children"
            class="wb-create-submenu-host"
            (mouseenter)="setCreateTradeSubmenu(true)"
            (mouseleave)="setCreateTradeSubmenu(false)"
          >
            <button
              type="button"
              class="dropdown-item wb-create-submenu-toggle"
              [attr.aria-expanded]="createTradeSubmenuOpen"
            >
              {{ item.label }}
              <i class="mdi mdi-chevron-right"></i>
            </button>
            <div class="wb-create-submenu" *ngIf="createTradeSubmenuOpen">
              <button
                *ngFor="let sub of item.children"
                type="button"
                class="dropdown-item"
                (click)="onCreate(sub.tranCategory); createDropdown.close()"
              >
                {{ sub.label }}
              </button>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    <ng-template #createAction>
      <button
        nf-button="create"
        ngbTooltip="Create Transaction"
        placement="bottom-right"
        (click)="onCreate()"
      ></button>
    </ng-template>
  </ng-grid-wrapper-header-right>

  <ng-grid-wrapper-header-right>
    <div ngbDropdown placement="bottom-right">
      <button
        ngbDropdownToggle
        nf-icon-button
        class="workbench-actions-button"
        ngbTooltip="Transaction Actions"
        placement="bottom-right"
        icon="dots-vertical"
        style="margin-left: 8px"
      >
        Transaction Actions
      </button>
      <div
        ngbDropdownMenu
        aria-labelledby="dropdown"
        class="dropdown-menu dropdown-menu-right"
      >
        <button
          type="button"
          class="dropdown-item btn btn-link"
          (click)="exportToExcel()"
        >
          Export to Excel
        </button>
      </div>
    </div>
  </ng-grid-wrapper-header-right>

  <ng-grid-wrapper-header-right>
    <button
      nf-icon-button="secondary"
      ngbTooltip="Filters Modal"
      placement="bottom-right"
      icon="filter"
      (click)="openFilters()"
      data-cy="advancedFiltersBtn"
    >
      Open Filters Modal
    </button>
    <hs-applied-filter-counts
      [filterCount]="filterCount"
    ></hs-applied-filter-counts>
  </ng-grid-wrapper-header-right>

  <ng-grid-wrapper-header-right>
    <button
      id="clear-all-filters-button"
      nf-icon-button="secondary"
      (click)="clearAll()"
      icon="filter-remove"
      ngbTooltip="Clear All Filters"
      [disabled]="!clearAllFiltersEnabled"
      placement="bottom-right"
    >
      Clear all filters
    </button>
  </ng-grid-wrapper-header-right>

  <nf-grid-wrapper-content *ngIf="gridOptions">
    <div class="wb-grid-area">
      <!-- Terminal states for the catalog fetch. These sit above the grid because the grid is
           still meaningful underneath: on error it falls back to the default columns, and an
           empty catalog is a legitimate answer (CW is not catalogued yet). The two error kinds
           read differently (item 10): a 404 is definitive (no metadata for this client) and offers
           no retry, while a 5xx is transient and offers a Retry. Both surface the errorId so a bug
           report can be keyed on it. -->
      <div
        *ngIf="!columnsLoading && columnsErrorKind === 'not-retryable'"
        class="wb-columns-status wb-columns-error"
        data-cy="columns-error-not-retryable"
      >
        <i class="mdi mdi-alert-circle"></i>
        <span>
          No column catalog is available for this source under the selected
          account — showing the default columns only.
          <span *ngIf="columnsErrorId" class="wb-columns-error-id"
            >Error ID: {{ columnsErrorId }}</span
          >
        </span>
      </div>
      <div
        *ngIf="!columnsLoading && columnsErrorKind === 'retryable'"
        class="wb-columns-status wb-columns-error"
        data-cy="columns-error-retryable"
      >
        <i class="mdi mdi-alert-circle"></i>
        <span>
          Couldn't load the column catalog — showing the default columns only.
          <span *ngIf="columnsErrorId" class="wb-columns-error-id"
            >Error ID: {{ columnsErrorId }}</span
          >
        </span>
        <button
          type="button"
          class="btn btn-link btn-sm wb-columns-retry"
          data-cy="columns-retry"
          (click)="retryFetch()"
        >
          Retry
        </button>
      </div>
      <div
        *ngIf="!columnsLoading && !columnsError && columnsEmpty"
        class="wb-columns-status wb-columns-empty"
        data-cy="columns-empty"
      >
        <i class="mdi mdi-information-outline"></i>
        No columns are catalogued for this source yet.
      </div>

      <!-- A chosen comparison type the data contradicts (a Number condition on an agg_info key
           holding ""). Presented differently from a plain failure because it is actionable and
           per-column: the backend names every field that claimed the failing type, and resetting
           them all to Text is the fix. Retry is deliberately NOT offered — the same request would
           fail identically. flex-transactions does not send this 400 yet (PVAL-26129 §6); until it
           does, that case arrives as a 500 and is reported by the error toast alone. -->
      <div
        *ngIf="!columnsLoading && canResetTypesToText"
        class="wb-columns-status wb-columns-error"
        data-cy="query-type-error"
      >
        <i class="mdi mdi-alert-circle"></i>
        <span>{{ queryFailureMessage }}</span>
        <button
          type="button"
          class="btn btn-link btn-sm wb-columns-retry"
          data-cy="reset-types-to-text"
          (click)="resetTypesToText()"
        >
          Reset to Text
        </button>
      </div>

      <!-- Match / Unmatch feedback. The failure is rethrown to the component precisely so the
           server's own per-validation message can be shown here, beside the grid it applies to and
           verbatim. A 400/409 shows up here ONLY (`WORKFLOW_ERROR_STATUSES` bypasses the global
           error drawer); any other status is also recorded there as a defect. The pending variant is
           for an action the server accepted but whose effect has not appeared yet — the write path
           is asynchronous, so "accepted" and "applied" are different facts and are reported as
           such. -->
      <div
        *ngIf="actionError"
        class="wb-columns-status wb-columns-error"
        data-cy="action-error"
        role="alert"
      >
        <i class="mdi mdi-alert-circle"></i>
        <span>{{ actionError }}</span>
        <button
          type="button"
          class="btn btn-link btn-sm wb-columns-retry"
          data-cy="action-message-dismiss"
          (click)="dismissActionMessage()"
        >
          Dismiss
        </button>
      </div>
      <div
        *ngIf="!actionError && actionPending"
        class="wb-columns-status wb-columns-empty"
        data-cy="action-pending"
        role="status"
        aria-live="polite"
      >
        <i class="mdi mdi-information-outline"></i>
        <span *ngIf="actionPendingNeedsRun; else pendingSoon">
          The match was submitted and is waiting for the next Run. These
          transactions will show as matched after it completes.
        </span>
        <ng-template #pendingSoon>
          <span>
            The action was accepted but has not been applied yet. The grid will
            update when it is.
          </span>
        </ng-template>
        <button
          type="button"
          class="btn btn-link btn-sm wb-columns-retry"
          data-cy="action-message-dismiss"
          (click)="dismissActionMessage()"
        >
          Dismiss
        </button>
      </div>

      <!-- Hold / Ignore succeeded. Distinct from the pending strip above: nothing is outstanding,
           the write is durable, and what the user is being told is that 2.0 cannot show it back or
           undo it. It has to be said here, on the success path — the rejection copy only ever
           reaches the user whose action did NOT go through. Ranked below the other two so a failure
           or an unapplied action is never displaced by it. -->
      <div
        *ngIf="!actionError && !actionPending && actionNote"
        class="wb-columns-status wb-columns-empty"
        data-cy="action-note"
        role="status"
        aria-live="polite"
      >
        <i class="mdi mdi-information-outline"></i>
        <span>{{ actionNote }}</span>
        <button
          type="button"
          class="btn btn-link btn-sm wb-columns-retry"
          data-cy="action-message-dismiss"
          (click)="dismissActionMessage()"
        >
          Dismiss
        </button>
      </div>

      <nf-table-layout
        [hideTitle]="true"
        [isSectionTitle]="true"
        [gridOptions]="gridOptions"
        [modules]="gridModules"
        hideSearch
        hideClearAll
        [autoResizeGrid]="false"
      >
      </nf-table-layout>

      <!-- While the catalog is in flight the grid underneath still shows the previous source's
           columns, so a strip of text beside it reads as "the grid is ready, something else is
           loading". Masking the whole area — headers included — reads as what is actually
           happening: this grid is being rebuilt around a new set of columns.

           The ROW fetch deliberately does NOT use this mask. By then the columns are built, so the
           headers should stay on screen and only the body shows a spinner — that is ag-Grid's own
           loading overlay, raised in `loadRows`. -->
      <div
        *ngIf="columnsLoading"
        class="wb-grid-loading"
        data-cy="columns-loading"
        role="status"
        aria-live="polite"
      >
        <span class="spinner-border" aria-hidden="true"></span>
        <span class="wb-grid-loading-label">Loading...</span>
      </div>
    </div>
  </nf-grid-wrapper-content>
</nf-grid-wrapper>
